import { appendQuery, objectToQuerystringEnhanced } from '@agnostack/lib-utils-js'
import { getData, DYNAMIC_DATA, DEFAULT_ID } from '@agnostack/lib-core'

import { useAsyncMemo } from './useAsyncMemo'

export const useMeetingUrl = (_baseUrl, { calendar, params, fallback = true } = {}) => (
  useAsyncMemo(async () => {
    try {
      let baseUrl = _baseUrl
      if (!baseUrl) {
        const calendarsData = await getData(DYNAMIC_DATA.CALENDARS)
        if (calendarsData?.[calendar]) {
          baseUrl = calendarsData[calendar]
        } else {
          baseUrl = fallback ? calendarsData?.[DEFAULT_ID] : undefined
        }
      }

      if (!baseUrl) {
        return undefined
      }

      const _meetingUrl = new URL(baseUrl)

      return appendQuery(_meetingUrl.href, objectToQuerystringEnhanced(params, { pruneEmpty: true }))
    } catch {
      return undefined
    }
  }, [_baseUrl, params])
)
